/* eslint-disable camelcase */
import { invisiblyApi } from '../../../redux/api/invisibly-api';
import { InvisiblyApiResponse } from '../../../services/api/api-response.types';
import { AggregateDataApiResponse, GetPerformanceDataParams, TimeSeriesDataApiResponse } from '../types/performance.types';

const overviewEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getOverviewAggregateData: builder.query<AggregateDataApiResponse, GetPerformanceDataParams>({
      query: ({ start_date, end_date, filter }) => ({
        method: 'GET',
        url: 'b2b/performance/aggregate',
        params: {
          start_date,
          end_date,
          filter,
        },
      }),
      transformResponse(response: InvisiblyApiResponse<AggregateDataApiResponse>) {
        return response.item;
      },
    }),
    getOverviewTimeSeriesData: builder.query<TimeSeriesDataApiResponse, GetPerformanceDataParams>({
      query: ({ start_date, end_date, filter }) => ({
        method: 'GET',
        url: 'b2b/performance/time_series',
        params: {
          start_date,
          end_date,
          filter,
        },
      }),
      transformResponse(response: InvisiblyApiResponse<TimeSeriesDataApiResponse>) {
        return response.item;
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetOverviewAggregateDataQuery,
  useGetOverviewTimeSeriesDataQuery,
} = overviewEndpoints;